module.exports = __webpack_public_path__ + "img/backIconLeft.205b0f45.png";